/**
 * Splits a pascalCased string into words.
 * @param text A pascalCased string, e.g. `"HelloWorld"`
 * @returns A string with separated words, e.g. `"Hello World"`. `String.trim()` is also applied to the result.
 */
export const splitPascalCase = (text: string) => {
  return text.replace(/([A-Z])/g, " $1").trimStart()
}

/**
 * Formats a string.
 * @param formatStr A string like `"Hello {there}!"`
 * @param values An object like `{ there: "beauty" }`
 * @returns A formatted string like "Hello beauty!"
 */
export function formatUnicorn(formatStr: string, ...values: any[]): string {
  if (values.length) {
    const type = typeof values[0]
    const args =
      type === "string" || type === "number"
        ? Array.prototype.slice.call(values)
        : values[0]
    for (const arg in args) {
      formatStr = formatStr.replace(new RegExp(`\\{${arg}\\}`, "gi"), args[arg])
    }
  }
  return formatStr
}
